// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as CookieConstants$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/constants/CookieConstants.mjs";
import * as LocaleConstants$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/constants/LocaleConstants.mjs";
import * as RecaptchaConstants$PorterinFeature from "../constants/RecaptchaConstants.mjs";
import * as CookieConsentManager$PorterinCookieConsentManager from "../../../../../../node_modules/@porterin/cookie-consent-manager/src/interface/CookieConsentManager.mjs";

function reloadAfterRecaptchaFailure(isRecaptchaFailed) {
  if (!isRecaptchaFailed) {
    return ;
  }
  var timer = setTimeout((function (param) {
          window.location.reload();
        }), RecaptchaConstants$PorterinFeature.recaptchaReloadTimeout);
  return (function (param) {
            clearTimeout(timer);
          });
}

function getTypeFromString(category) {
  return /* TwoWheelers */0;
}

function capitalize(str) {
  if (str.length <= 0) {
    return str;
  }
  var first_letter = str.slice(0, 1);
  var remaining_string = str.slice(1);
  var capitalized_first_letter = first_letter.toLocaleUpperCase();
  return "" + capitalized_first_letter + "" + remaining_string + "";
}

function getOverflowStyle(len, styles) {
  if (len < 4) {
    return styles["min-overflow"];
  } else if (len !== 4) {
    return "";
  } else {
    return styles["overflow-4"];
  }
}

function scrollToElement(ele) {
  return ele.scrollIntoView({
              behavior: "smooth",
              block: "end",
              inline: "nearest"
            });
}

function isError(field) {
  if (field !== undefined && field.TAG !== /* Ok */0) {
    return true;
  } else {
    return false;
  }
}

function getNextLocaleCookieString(locale) {
  var maxAge = String(18144000);
  return "" + CookieConstants$PorterinUtils.next_locale + "=" + locale + "; maxage=" + maxAge + "; path=/";
}

function requirementToString(requirement) {
  switch (requirement) {
    case /* Personal */0 :
        return "Personal";
    case /* Business */1 :
        return "Business";
    case /* HouseShift */2 :
        return "House Shift";
    
  }
}

function triggerAcceptAllCookies(locale) {
  if (LocaleConstants$PorterinUtils.trLocales.includes(locale)) {
    return CookieConsentManager$PorterinCookieConsentManager.acceptAllCookies(undefined);
  }
  
}

function getPickupDetail(query_params) {
  var fromAddressLandmark = Js_dict.get(query_params, "from_address_landmark");
  var fromAddressLat = Js_dict.get(query_params, "from_address_lat");
  var fromAddressLng = Js_dict.get(query_params, "from_address_long");
  return [
          fromAddressLandmark,
          fromAddressLat,
          fromAddressLng
        ];
}

function roundOffCurrency(fare) {
  return Number(fare.toFixed(2));
}

function getRandomIdName(prefix) {
  var randomIdAsString = String(Math.random());
  return prefix + "-" + randomIdAsString;
}

function showTestimonials(data) {
  if (data.title !== "") {
    return data.testimonials.length > 0;
  } else {
    return false;
  }
}

function isNumeric(value) {
  var regex = /^\d+$/;
  var _data = regex.exec(value);
  return _data !== null;
}

export {
  reloadAfterRecaptchaFailure ,
  getTypeFromString ,
  capitalize ,
  getOverflowStyle ,
  scrollToElement ,
  isError ,
  getNextLocaleCookieString ,
  requirementToString ,
  triggerAcceptAllCookies ,
  getPickupDetail ,
  roundOffCurrency ,
  getRandomIdName ,
  showTestimonials ,
  isNumeric ,
}
/* CookieConsentManager-PorterinCookieConsentManager Not a pure module */
